import {
  AULA_DARK_ALERT_INFO_BG_COLOR,
  AULA_LIGHT_ALERT_INFO_BG_COLOR,
} from '@ublend-npm/aulaui-core';

export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    icon: {
      width: '22px',
      height: '22px',
    },
    alert: {
      bgcolor: isDark
        ? AULA_DARK_ALERT_INFO_BG_COLOR
        : AULA_LIGHT_ALERT_INFO_BG_COLOR,
      border: 'none',
      borderRadius: '8px',
      alignItems: 'flex-start',
      '& .MuiAlert-icon': {
        color: isDark ? '#29B6F6' : '#0288D1',
        marginTop: '2px',
      },
      '& .MuiAlert-message': {
        fontFamily: theme?.typography?.fontFamily,
        fontWeight: theme?.typography?.fontWeightRegular,
        fontSize: '0.875rem',
        lineHeight: '143%',
        letterSpacing: '0px',
        color: isDark ? '#B8E7FB' : '#014361',
        '& a': {
          color: isDark ? '#D0BCFA' : '#0288D1',
        },
      },
    },
    title: {
      display: 'block',
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium,
      fontSize: '1rem',
      lineHeight: '150%',
      letterSpacing: '0.15px',
    },
    content: {
      display: 'block',
      marginTop: '2px',
    },
  };
};
